import React from "react";
import ReactDOM from 'react-dom';
import Button from '@material-ui/core/Button';
import { format, set, addMinutes } from "date-fns";
import { Requests } from "../../api/IdentityServerRequests/Requests";
import copy from "../../assets/copy/copy.json"
import QualificationsList from "../Availability/QualificationsList";
import Loader from "../../components/UI/Loading/Loading";
import ReactPaginate from 'react-paginate';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ReactComponent as BackButton } from "../../assets/img/icons/back-arrow.svg";
import RightArrow from "../../assets/img/icons/rightarrow.svg";

const myDashboard = window.scheduler;
export default class MyDashboard extends React.PureComponent {
  constructor(props) {
    super(props);
    this.Requests = new Requests();
    this.retrieveDocNode = this.retrieveDocNode.bind(this);
    this.schedulerHeaderlabels = this.schedulerHeaderlabels.bind(this);
    this.schedulerSubHeaderContent = this.schedulerSubHeaderContent.bind(this);
    this.customViewChange = this.customViewChange.bind(this);
    this.batchCount = 100;
    this.state = {
      isInitialLoad: true,
      isComponentLoading: false,
      threeDaysViewName: "3_days",
      threeDaysLabelName: "3 Days",
      threeDaysTabName: "3_days_tab",
      currentDate: new Date(),
      rowHeight: 65,
      usersResponse: {},
      qualificationsListPopup: false,
      selectedUser: null,
      userQualifications: [],
      skipNumber: 0,
      pageCount: 0,
      currentPage: 0,
    };
  }

  schedulerHeaderlabels(dates, nav) {
    const html = `
     <div class='dhx_date_header_labels_container'>
      ${nav?.leftNav ? "<div id='prev-button' class='dhx_cal_prev_button dhx_cal_nav_button dhx_cal_week_prev_custom' role='button' aria-label='Previous'></div>" : ""}
        <div class='dhx_date_header_labels' aria-label='${dates}' >
          <div>${dates}</div>
        </div>
      ${nav?.rightNav ? "<div id='next-button' class='dhx_cal_next_button dhx_cal_nav_button dhx_cal_week_next_custom' role='button' aria-label='Next'></div>" : ""}
    </div>
  `;
    return html;
  }

  customViewChange(event) {
    if (event.target.value == "week") {
      myDashboard.setCurrentView(myDashboard.getState.min_date, "week");
    }
    if (event.target.value == "3_days") {
      myDashboard.setCurrentView(myDashboard.getState.min_date, "3_days");
    }
  }

  retrieveDocNode(cssClassName) {
    return document.querySelector(cssClassName)
  }

  addPrevNextDayArrows() {
    const schedulerContainer = this.retrieveDocNode('.dhx_cal_header')
    if (schedulerContainer) {
      const prevButtonContainer = document.createElement('div')
      const nextButtonContainer = document.createElement('div')
      prevButtonContainer.className = 'prevButtonContainer'
      nextButtonContainer.className = 'nextButtonContainer'
      const prevButton = <div className="dhx_cal_prev_button dhx_cal_prev_month_button dhx_cal_nav_button" role="button" aria-label="Previous"></div>
      const nextButton = <div className="dhx_cal_next_button dhx_cal_next_month_button dhx_cal_nav_button" role="button" aria-label="Next"></div>
      schedulerContainer.insertBefore(prevButtonContainer, schedulerContainer.firstChild)
      schedulerContainer.appendChild(nextButtonContainer)
      ReactDOM.render(prevButton, prevButtonContainer)
      ReactDOM.render(nextButton, nextButtonContainer)
    }
  }

  addQualificationTags = () => {
    const rows = document.querySelectorAll('.dhx_timeline_label_row')
    const calDataRightOffset = document.querySelector('#myDashboard').getBoundingClientRect().right
    const spaceForEllipsis = 70
    const qualificationCodes = this.props.qualifications.map(q => q.key)
    // match the data-row-id to the user and add qualification tags
    rows.forEach(row => {
      let offScreenQualifications = []
      let rowLabel = row.querySelector('.dhx_timeline_label_content_wrapper')
      if ((this.props.width <= 1023)) {
        rowLabel.parentElement.style.setProperty('flex-direction', 'column')
      } else {
        rowLabel.parentElement.style.setProperty('flex-direction', 'row')
      }
      let qualContainer = document.createElement('div')
      qualContainer.className = 'qualificationContainer'
      rowLabel.parentElement.append(qualContainer)
      let rowId = row.attributes['data-row-id'].value
      let user = this.state.usersResponse.find(({ UserId }) => UserId === rowId)
      user?.qualifications?.forEach(qual => {
        if (qualificationCodes.includes(qual.id)) {
          let qualTag = document.createElement('div')
          qualTag.addEventListener('click', () => this.triggerIndividualQualifications(user))
          let textNode = document.createTextNode(qual.name)
          qualTag.className = 'qualificationTag'
          qualTag.appendChild(textNode)
          qualContainer.append(qualTag)
          let rightEdge = qualTag.getBoundingClientRect().right
          if (rightEdge >= calDataRightOffset - spaceForEllipsis) {
            offScreenQualifications.push(qualTag)
          }
        }

      })
      let count = offScreenQualifications.length
      offScreenQualifications.forEach(qualTag => qualTag.remove())
      if (count > 0) {
        let countTag = document.createElement('div')
        countTag.addEventListener('click', () => this.triggerIndividualQualifications(user))
        let textNode = document.createTextNode(`+${count}...`)
        countTag.className = 'qualificationTag'
        countTag.appendChild(textNode)
        qualContainer.append(countTag)
      }
    })
  }

  removeQualificationTags = () => {
    document.querySelectorAll('.qualificationContainer').forEach(e => e?.remove())
  }

  schedulerHeaderDetails() {
    const smallScreen = this.props.width <= 1067
    if (smallScreen) {
      document.querySelector('.carousel-container dashboard')?.remove();
    }
    const date = this.state.currentDate;
    const options = { day: 'numeric', year: 'numeric', month: smallScreen ? 'short' : 'long' };
    const weekdayOptions = { weekday: 'long' }
    const currentMonth = new Intl.DateTimeFormat('default', options).format(date);
    const currentWeekday = new Intl.DateTimeFormat('default', weekdayOptions).format(date)
    return (
      <div>
        <div className="headerDetails" id="membersAvailabilityHeader">
          {smallScreen ? (
            <>
              {this.props.popupButtons?.addAvailabilityButton}
              {this.props.popupButtons?.setPagingGroupButton}
            </>
          ) : (
            <div className="leftControls">
              {this.props.popupButtons?.addAvailabilityButton}
              {this.props.popupButtons?.setPagingGroupButton}
            </div>
          )}
          <div className="prevButtonContainer" role="button">
            <div className="dhx_cal_prev_button dhx_cal_prev_month_button dhx_cal_nav_button" role="button" aria-label="Previous"></div>
            {this.props.width > 1067 && <span className="bold">{copy.myAvailabilityScreen.membersAvailability.prev}</span>}
          </div>

          <div className="carousel-month active" id="calendar-picker" aria-label={currentMonth} onClick={this.showCalendar}>
            <span className="dhx_minical_icon" id="dhx_minical_icon">{currentMonth}</span>
          </div>
          <div className="nextButtonContainer" role="button">
            {this.props.width > 1067 && <span className="bold">{copy.myAvailabilityScreen.membersAvailability.next}</span>}
            <div className="dhx_cal_next_button dhx_cal_next_month_button dhx_cal_nav_button" role="button" aria-label="Next"></div>
          </div>
          {smallScreen ? (
            <>
              {this.props.popupButtons?.ellipsesDropdown}
              {this.props.popupButtons?.ellipsesDropdown && this.props.hasQualifications && <div className="verticalRule"></div>}
              {this.props.popupButtons?.qualificationsButton}
              {this.props.popupButtons?.qualificationsToggle}
            </>
          ) : (
            <div className="rightControls">
              {this.props.popupButtons?.ellipsesDropdown}
              {this.props.popupButtons?.ellipsesDropdown && this.props.hasQualifications && <div className="verticalRule"></div>}
              <div className="qualificationControls">
                {this.props.popupButtons?.qualificationsButton}
                {this.props.popupButtons?.qualificationsToggle}
              </div>
            </div>
          )
          }
        </div>

        <div className="dayOfWeek">{currentWeekday}</div>

      </div>

    );
  };
  schedulerSubHeaderContent(date) {
    const format = myDashboard.date.date_to_str('%H');
    let html = format(date)
    switch (html) {
      case "00":
        html = this.schedulerHeaderlabels(html, { leftNav: true });
        break;
      case "23":
        html = this.schedulerHeaderlabels(html, { rightNav: true });
        break;
      default:
        html = this.schedulerHeaderlabels(html);
    }
    return html;
  }
  navigateDayPrev = () => {
    const date = myDashboard.getState().date;
    const newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1);
    this.setState({ currentDate: newDate, currentPage: 0, skipNumber: 0 }, () => this.getUsers(this.updateTimeline))
  }

  navigateDayNext = () => {
    const date = myDashboard.getState().date;
    const newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
    this.setState({ currentDate: newDate, currentPage: 0, skipNumber: 0 }, () => this.getUsers(this.updateTimeline))
  }
  previousWeekButton() {
    return (
      <div class="dhx_cal_prev_button dhx_cal_nav_button" role="button" aria-label="Previous"></div>
    )
  }

  triggerIndividualQualifications = (user) => {
    const agencyQualifications = this.props.qualifications.map(q => q.key)
    const userHasQualifications = !!user.qualifications.filter(q => agencyQualifications.includes(q.id)).length
    this.setState({
      qualificationsListPopup: userHasQualifications,
      selectedUser: user,
      userQualifications: user.qualifications.map(qual => {
        return (
          {
            key: qual.id,
            value: qual.name
          }
        )
      }).filter(qual => agencyQualifications.includes(qual.key))
    })
  }
  attachEvents() {
    const rows = document.querySelectorAll('.dhx_timeline_label_row')
    rows.forEach(row => {
      let rowId = row.attributes['data-row-id'].value
      let user = this.state.usersResponse.find(({ UserId }) => UserId === rowId)
      let nameTag = row.querySelector('.dhx_timeline_label_content_wrapper')
      nameTag.removeEventListener('click', () => this.triggerIndividualQualifications(user))
      nameTag.addEventListener('click', () => this.triggerIndividualQualifications(user))
    })

    let navPrevDay = document.querySelector('.prevButtonContainer')
    let navNextDay = document.querySelector('.nextButtonContainer')

    navPrevDay?.removeEventListener('click', this.navigateDayPrev);
    navNextDay?.removeEventListener('click', this.navigateDayNext);
    navPrevDay?.addEventListener('click', this.navigateDayPrev);
    navNextDay?.addEventListener('click', this.navigateDayNext);

    let myDashboardParent = document.querySelector('#myDashboard').parentElement
    myDashboardParent?.removeEventListener("dblclick", this.preventDoubleClick, true)
    myDashboardParent?.addEventListener("dblclick", this.preventDoubleClick, true)
    myDashboardParent?.removeEventListener("touchstart", this.preventDoubleClick, true)
    myDashboardParent?.addEventListener("touchstart", this.preventDoubleClick, true)
  }

  preventDoubleClick = (event) => {
    event.stopImmediatePropagation()
  }

  nameFormat = (user) => `${user?.nameFirst} ${user?.nameLast}`

  reverseNameFormat = (user) => `${user?.nameLast} ${user?.nameFirst}`

  initialiseTimeline = (data) => {

    const y_unit = data.map((user) => {
      return ({
        key: user?.UserId,
        label: this.nameFormat(user)
      })
    })
    myDashboard.serverList("users", y_unit)
    myDashboard.skin = 'material';
    myDashboard.plugins({
      minical: true,
      timeline: true,
      treetimeline: true,
      daytimeline: true,
      units: true,
      recurring: true,
      all_timed: true,
    });

    // Create a custom "3_days" view
    myDashboard.config.mark_now = false;
    myDashboard.config.multi_day = true;
    myDashboard.config.all_timed = true;
    myDashboard.config.drag_create = false;
    myDashboard.config.drag_move = false;
    myDashboard.config.drag_resize = false;
    myDashboard.config.multisection = true;
    myDashboard.config.touch_tip = false;
    myDashboard.config.touch_tooltip = false;
    myDashboard.locale.labels["3_days_tab"] = "3 Days";


    myDashboard.date["3_days"] = function (date) {
      var ndate = new Date(date.valueOf());
      ndate.setDate(ndate.getDate() + 3);
      return ndate;
    };

    myDashboard.createUnitsView({
      name: "3_days",
      property: "key",
      list: [
        { key: 1, label: "" }
      ],
      days: 3
    });
    myDashboard.locale.labels.timeline_tab = "Timeline";
    myDashboard.createTimelineView({
      name: "timeline",
      x_unit: "minute", // measuring unit of the X-Axis.
      x_date: "%G",  // date format of the X-Axis
      x_step: 60,       // X-Axis step in 'x_unit's
      x_size: 24,       // X-Axis length specified as the total number of 'x_step's
      x_start: 0,      // X-Axis offset in 'x_unit's
      x_length: 48,     // number of 'x_step's that will be scrolled at a time
      y_unit: myDashboard.serverList("users"),
      dy: this.state.rowHeight,
      y_property: "UserId", // mapped data property
      render: "bar",             // view mode
      columns: [
        { width: 48, template: function (obj) { return obj.label } }
      ]
    });
    myDashboard.templates.time_slot_class = function (date) {
      if ((myDashboard.getState().mode === "week" && date.getDate() % 2 === 0) ||
        (myDashboard.getState().mode === "3_days") && date.getDate() % 2 !== 0) {
        return "custom_color";
      }
    };
    myDashboard.templates.timeline_scalex_class = function (date) {
      return "dashboardScaleBar"
    }
    myDashboard.templates.timeline_scaley_class = function (date) {
      return "dashboardLabel"
    }
    myDashboard.templates.timeline_cell_class = function (evs, date, section) {
      return "dashboardCell"
    }
    const weekDayLabel = myDashboard.date.date_to_str("%D");
    myDashboard.templates.calendar_scale_date = function (date) {
      // M | T | W | T | F | S | S
      return weekDayLabel(date).substr(0, 1);
    };
    const dayDate = myDashboard.date.date_to_str("%j");
    myDashboard.templates.calendar_date = function (date) {
      return dayDate(date)
    };
    myDashboard.templates.event_class = (start, end, event) => {
      let _cssClass = "";

      const eventType = event.eventType
      switch (eventType) {
        case "Available":
          _cssClass += "-available ";
          break;
        case "Emergency":
          _cssClass += "-emergency ";
          break;
        case "Other":
          _cssClass += "-other ";
          break;
        case "Unavailable":
          _cssClass += "-unavailable ";
          break;
        default:
          _cssClass += "undefined";
      }

      _cssClass += " dhx_cal_event customHeight"

      return _cssClass.trim();
    };
    this.eventParse = myDashboard.attachEvent("onParse", () => {
      const newRowHeight = ((this.props.width <= 1023) && this.props.qualificationsToggle) ? 92 : 65;
      this.changeRowHeight(newRowHeight);
      return true
    })

    this.eventTemplateReady = myDashboard.attachEvent("onTemplatesReady", () => {
      const schedulerContainer = document.querySelector('.dhx_cal_header');
      let timeRow = document.querySelector('.timeRowAfterSubHeader');
      if (!timeRow) {
        timeRow = document.createElement('div');
        timeRow.className = 'timeRowAfterSubHeader';
        timeRow.textContent = 'Time';
        schedulerContainer.parentNode.insertBefore(timeRow, schedulerContainer.nextSibling);
      }
      return true
    });
    myDashboard.attachEvent("onBeforeEventChanged", function (ev, e, is_new, original) {
      return true;
    });


    const navHeader = this.schedulerHeaderDetails();
    myDashboard.xy.nav_height = 80;
    myDashboard.config.header = [
      { html: navHeader },
    ];

    const availabilities = data.flatMap(user => {
      return (
        user.userAvailableTimeRange.map(this.availabilitiesToArray(user)).concat(
          user.userUnavailableTimeRange.map(this.availabilitiesToArray(user))
        )
      )
    })
    this.eventViewChange = myDashboard.attachEvent("onViewChange", (new_mode, new_date) => {
      this.attachEvents();
      const formatFunc = myDashboard.date.date_to_str('%F %Y');
      const currentMonth = formatFunc(myDashboard.getState().date);
      return true
    });
    this.onAfterSchedulerResize = myDashboard.attachEvent("onAfterSchedulerResize", () => {
      const timelineEvents = myDashboard.getEvents()
      myDashboard.clearAll()
      myDashboard.parse(timelineEvents)
    })
    myDashboard.init(this.myDashboard, this.state.currentDate, 'timeline');

    myDashboard.clearAll();
    myDashboard.parse(availabilities);
  }

  availabilitiesToArray = user => block => {
    const [startHours, startMinutes] = block.timeStart.split(':')
    const [endHours, endMinutes] = block.timeEnd.split(':')
    const timeStart = new Date(this.state.currentDate);
    timeStart.setHours(startHours, startMinutes);

    const timeEnd = new Date(this.state.currentDate);
    timeEnd.setHours(endHours, endMinutes);

    const start_date = format(timeStart, "yyyy-MM-dd HH:mm");
    const end_date = format(timeEnd, "yyyy-MM-dd HH:mm");
    return ({
      start_date,
      end_date,
      UserId: user.UserId,
      eventType: block.AvailabilityType || "Unavailable"
    })
  }

  componentDidMount() {
    if (this.props.selectedPagingGroups) {
      this.getUsers(this.initialiseTimeline);
      this.setState({ isInitialLoad: false });
    }
    document.documentElement.style.setProperty('--timeline-row-height', `${this.state.rowHeight}px`, "important");
    if (this.props.addNotchSafePadding) {
      this.props.addNotchSafePadding();
    }
  }

  componentWillUnmount() {
    this.detachEvents();
  }

  detachEvents = () => {
    myDashboard.detachEvent(this.eventParse)
    myDashboard.detachEvent(this.eventTemplateReady)
    myDashboard.detachEvent(this.eventViewChange)
    myDashboard.detachEvent(this.onAfterSchedulerResize)
  }

  restoreDynamicallyRenderedElements = () => {
    if (this.props.qualificationsToggle) {
      this.addQualificationTags();
    }
    if (myDashboard.isCalendarVisible()) {
      this.addMinicalCross();
      this.minicalMonthNavigation();
    }
    this.removeRowSpacing()
    this.repositionEventBlocks()
    this.addNoMoreMessages()
    this.attachEvents();
  }

  repositionEventBlocks = () => {
    // move the timeline events below the user tags
    const rows = document.querySelectorAll(".dhx_matrix_line")
    rows.forEach(row => {
      const extractInt = (a) => parseInt((a).slice(0, -2))
      const eventBlocks = row.querySelectorAll(".dhx_cal_event_line")
      const blockLeftRightValues = [...eventBlocks].map(block => {
        let left = extractInt(block.style.left)
        let right = left + extractInt(block.style.width)
        return ({ left, right })
      })
      const maxCallback = (a, b) => Math.max(a, b)
      const minCallback = (a, b) => Math.min(a, b)
      const blockTopValues = [...eventBlocks].map(b => b.style.top).map(extractInt)
      const maxTopValue = blockTopValues.reduce(maxCallback, 0)
      const singleLevel = maxTopValue === blockTopValues.reduce(minCallback, Number.POSITIVE_INFINITY)
      eventBlocks.forEach(block => {
        let secondLevelBlock = (extractInt(block.style.top) === maxTopValue) && !singleLevel
        block.style.top = `${parseInt((block.style.top).slice(0, -2)) + (this.state.rowHeight - 29) - (secondLevelBlock && 10)}px`
        let leftValue = extractInt(block.style.left)
        let rightValue = leftValue + extractInt(block.style.width)
        let overlappingBlocks = blockLeftRightValues
          .filter(currentLeftRightValue =>
            ((leftValue >= currentLeftRightValue.left) && (leftValue < currentLeftRightValue.right))       // left edge not inside any other block
            || ((rightValue > currentLeftRightValue.left) && (rightValue <= currentLeftRightValue.right))  // right edge not inside any other block
            || ((leftValue < currentLeftRightValue.left) && (rightValue > currentLeftRightValue.right))    // interval does not contain any other block
          )
        let singleAvailabilityBlock = overlappingBlocks.length === 1
        if (singleAvailabilityBlock) {
          block.classList.remove('customHeight')
          block.classList.add('fullHeight')
        }
      })
    })
  }

  removeRowSpacing = () => {
    const reposition = (elements) => {
      elements.forEach((e, i) => {
        e.style.top = `${i * this.state.rowHeight}px`
      })
    }
    const rows = [...document.querySelectorAll(".dhx_matrix_line")]
    const labels = [...document.querySelectorAll(".dhx_timeline_label_row")]
    reposition(rows)
    reposition(labels)
  }

  addNoMoreMessages = () => {
    let rows = document.querySelectorAll('.dhx_matrix_line')
    let finalRow = rows[rows.length - 1]
    if (!finalRow) {
      finalRow = document.querySelector('.dhx_timeline_data_col')
    }
    let messageHeight = parseInt(getComputedStyle(finalRow).getPropertyValue('top').slice(0, -2)) + this.state.rowHeight
    let noMoreUsersMessage = document.createElement('div');
    noMoreUsersMessage.style.setProperty('margin-top', '0.4rem');
    noMoreUsersMessage.style.setProperty('top', `${messageHeight}px`)
    noMoreUsersMessage.className = 'noMoreUsersMessage'
    noMoreUsersMessage.textContent = copy.myAvailabilityScreen.membersAvailability.listEndMessage;
    finalRow.parentElement.append(noMoreUsersMessage);
  }

  updateTimeline = (data) => {
    const y_unit = data.map((user) => {
      return ({
        key: user?.UserId,
        label: this.nameFormat(user)
      })
    })
    myDashboard.updateCollection("users", y_unit)
    myDashboard.setCurrentView(this.state.currentDate)

    const availabilities = data.flatMap(user => {
      return (
        user.userAvailableTimeRange.map(this.availabilitiesToArray(user)).concat(
          user.userUnavailableTimeRange.map(this.availabilitiesToArray(user))
        )
      )
    })

    myDashboard.clearAll();
    myDashboard.parse(availabilities);
  }

  setIntersection = (criteriaArray, comparisonArray) => {
    const criteriaSet = new Set(criteriaArray)
    const comparisonSet = new Set(comparisonArray)
    if (comparisonSet.size === 0) {
      return true
    }
    return !criteriaSet.isDisjointFrom(comparisonSet)
  }

  sortUsers = (users) => {
    const orderingType = this.props.sortByOption
    const nameFormatFunction = this.props.sortByFirstName ? this.nameFormat : this.reverseNameFormat
    const nameComparison = (a, b) => {
      const nameA = nameFormatFunction(a).toUpperCase()
      const nameB = nameFormatFunction(b).toUpperCase()
      if (nameA < nameB) {
        return -1
      }
      if (nameA > nameB) {
        return 1
      }
      return 0;
    }
    const userAvailabilityTypes = (user) =>
      user.userAvailableTimeRange.map(block => block.AvailabilityType)
        .concat(user.userUnavailableTimeRange.length ? ["Unavailable"] : [])
    const hasAvailability = (a, b) => {
      const userA = userAvailabilityTypes(a).length > 0
      const userB = userAvailabilityTypes(b).length > 0
      if (userA < userB) {
        return 1
      } else if (userA > userB) {
        return -1
      }
      return 0;
    }
    const availabilityTypeComparison = (a, b) => {
      const userA = this.setIntersection(userAvailabilityTypes(a), [this.props.sortByType])
      const userB = this.setIntersection(userAvailabilityTypes(b), [this.props.sortByType])
      if (userA < userB) {
        return 1
      } else if (userA > userB) {
        return -1
      }
      return 0;
    }
    const alphabetic = copy.myAvailabilityScreen.membersAvailability.sortByOptions.alpha;
    const enteredAvail = copy.myAvailabilityScreen.membersAvailability.sortByOptions.avail;
    switch (orderingType) {
      case alphabetic:
        if (this.props.sortByAtoZ) {
          users.sort(nameComparison)
        } else {
          users.sort((a, b) => nameComparison(b, a))
        }
        break;
      case enteredAvail:
        (users.sort(hasAvailability)).sort(availabilityTypeComparison)
        break;
      default:
        break;
    }
    return users
  }

  showCalendar = () => {
    const calIcon = document.querySelector('.dhx_minical_icon')
    const bottom = calIcon.getBoundingClientRect().bottom
    const left = calIcon.getBoundingClientRect().left - 135 + 50
    const centerPosition = {left: left, top: bottom}
    if (window.innerWidth < 767) {
      centerPosition.left = (window.innerWidth / 2) - 135
    }
    if (window.innerHeight < 667) {
      centerPosition.top = (window.innerHeight / 2) - 160
    }
    const smallScreen =  (window.innerWidth < 767) || (window.innerHeight < 767)
    
    if (myDashboard.isCalendarVisible()) {
      myDashboard.destroyCalendar();
    } else {
      myDashboard.renderCalendar({
        position: smallScreen ? centerPosition : { left: left, top: bottom },
        date: myDashboard.getState().date,
        navigation: true,
        handler: (date, calendar) => {
          this.setState({ currentDate: date, currentPage: 0, skipNumber: 0 }, () => {
            this.getUsers(this.updateTimeline)
          })
        }
      })
      this.addMinicalCross()
      this.minicalMonthNavigation()
    }
  }



  addMinicalCross = () => {
    let minical = document.querySelector('.dhx_mini_calendar').querySelector('.dhx_year_month')
    let closeButton = document.createElement('button')
    closeButton.addEventListener('click', () => myDashboard.destroyCalendar())
    closeButton.className = "closeAlertControls__btn -close"
    closeButton.style.setProperty('position', 'absolute')
    closeButton.style.setProperty('right', '8px')
    closeButton.style.setProperty('top', '8px')
    minical.appendChild(closeButton)
  }

  minicalMonthNavigation = () => {
    // add event listeners to the forward/back arrows for adding the cross
    let minical = document.querySelector('.dhx_mini_calendar')
    let nextArrow = minical.querySelector('.dhx_cal_next_button')
    let prevArrow = minical.querySelector('.dhx_cal_prev_button')
    nextArrow.addEventListener('click', this.addMinicalCross)
    prevArrow.addEventListener('click', this.addMinicalCross)
    nextArrow.addEventListener('click', this.minicalMonthNavigation)
    prevArrow.addEventListener('click', this.minicalMonthNavigation)
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.isInitialLoad && this.props.selectedPagingGroups !== prevProps.selectedPagingGroups) {
      this.getUsers(this.initialiseTimeline);
    }
    if (
      (this.props.selectedAvailabilityTypes !== prevProps.selectedAvailabilityTypes) ||
      (this.props.selectedQualifications !== prevProps.selectedQualifications) ||
      (this.props.sortByOption !== prevProps.sortByOption) ||
      (this.props.sortByType !== prevProps.sortByType) ||
      (this.props.sortByAtoZ !== prevProps.sortByAtoZ) ||
      (this.props.sortByFirstName !== prevProps.sortByFirstName)
    ) {
      this.updateTimeline(this.sortUsers(this.applyFilters(this.state.usersResponse)));
    }
    if (this.props.qualificationsToggle !== prevProps.qualificationsToggle) {
      const newRowHeight = ((this.props.width <= 1023) && this.props.qualificationsToggle) ? 92 : 65;
      this.changeRowHeight(newRowHeight)
    }
    if (this.props.width !== prevProps.width) {
      // destroy timeline, remove UI elements around timeline
      myDashboard.destroyCalendar();
      this.detachEvents();
      let dashboard = document.querySelector('#myDashboard')
      dashboard.childNodes.forEach(child => child.remove())
      myDashboard.init(this.myDashboard, this.state.currentDate, 'timeline');
      this.initialiseTimeline(this.sortUsers(this.applyFilters(this.state.usersResponse)));
    }
  }

  changeRowHeight = (height) => {
    document.documentElement.style.setProperty('--timeline-row-height', `${height}px`, "important")
    myDashboard.getView('timeline').dy = height
    myDashboard.setCurrentView();
    this.setState({ rowHeight: height }, () => {
      this.restoreDynamicallyRenderedElements();
    })
  }

  applyFilters = (users) => {
    const userAvailabilityTypes = (user) =>
      user.userAvailableTimeRange.map(block => block?.AvailabilityType)
        .concat(user.userUnavailableTimeRange?.length ? ["Unavailable"] : [])
    const filteredData = users
      .filter(user => this.setIntersection(user.qualifications.map(q => (q.id).toString()), this.props.selectedQualifications))
      .filter(user => this.setIntersection(userAvailabilityTypes(user), this.props.selectedAvailabilityTypes))
    return filteredData
  }
  getUsers = (callback) => {
    const apiDate = format(this.state.currentDate, 'yyyy-MM-dd')
    const pagingNumber = this.props.selectedPagingGroups
    // call to users API to get a list of users in the currently selected paging group
    const API_ENDPOINT = this.Requests.getPagingGroupUsersAndAvailability;
    this.setState({ isComponentLoading: true });
    this.Requests.callAPI(
      API_ENDPOINT,
      { skip: this.state.skipNumber, take: this.batchCount, order: "ASC" },
      pagingNumber,
      apiDate
    ).then((data) => {
      // put users in column
      if (data?.status === 200) {
        this.setState({
          usersResponse: data.data.userAvailabilitiesPerDate,
          isComponentLoading: false,
          pageCount: Math.ceil(data.data.count / this.batchCount),
        }, () => callback(this.sortUsers(this.applyFilters(this.state.usersResponse))))
      } else {
        // error
        console.log("error fetching paging group availability")
      }
    })
  }

  updateQualificationFilter = (qualifications) => {
    const filterSet = new Set(qualifications)
    this.setState({
      qualificationsSet: filterSet
    })
  }

  updateAvailabilityTypeFilter = (availabilityTypes) => {
    const filterSet = new Set(availabilityTypes)
    this.setState({
      availabilityTypesSet: filterSet
    })
  }
  handlePageClick = (event) => {
    const skipCount = (event.selected * this.batchCount);
    this.setState({
      currentPage: event.selected,
      skipNumber: skipCount,
    }, () => this.getUsers(this.updateTimeline));
  };

  setTimeFormat(state) {
    myDashboard.config.first_hour = 1;
    myDashboard.config.last_hour = 24;
    myDashboard.templates.hour_scale = function (date) {
      var hour = date.getHours();
      return hour; // returns the hour without leading zeros
    };
  }

  render() {
    const { timeFormatState } = this.props;
    const previousPageLabel = (
      <div className={`back-button-container ${window.cordova ? 'touch-device' : ''}`} aria-label="Previous Page">
        <BackButton className="back-button" />
        <span className="page-previous-next">Previous</span>
      </div>
    );
    const nextPageLabel = (
      <div className={`right-button-container ${window.cordova ? 'touch-device' : ''}`} aria-label="Next Page">
        <span className="page-previous-next">Next</span>
        <BackButton className="right-button" />
      </div>
    );
    this.setTimeFormat(timeFormatState);
    const showOrHidePaginationGap =
      this.state.pageCount <= 1 ? 'count-less-than-or-equal-to-1' : 'count-greater-than-1';
    return (
      <>
        {this.schedulerHeaderDetails()}
        {this.state.qualificationsListPopup && <QualificationsList
          isVisible={this.state.qualificationsListPopup}
          favourites={this.props.qualificationFavourites}
          onClose={() => this.setState({ qualificationsListPopup: false })}
          titleText={copy.myAvailabilityScreen.membersAvailability.qualificationsPopup.title}
          subtitleText={this.nameFormat(this.state.selectedUser)}
          qualifications={this.state.userQualifications}
        />}
        <div id="dashboard_wrapper">
          <div
            id="myDashboard"
            className={showOrHidePaginationGap}
            ref={(input) => { this.myDashboard = input }}>
            {this.state.isComponentLoading ? (<div className="loader-container"><Loader /></div>) : (<></>)}
          </div>
          {this.state.pageCount > 1 &&
            (<ReactPaginate
              onPageChange={this.handlePageClick}
              pageRangeDisplayed={3}
              marginPagesDisplayed={1}
              pageCount={this.state.pageCount}
              previousLabel={previousPageLabel}
              nextLabel={nextPageLabel}
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination"
              activeClassName="active"
              renderOnZeroPageCount={null}
              forcePage={this.state.currentPage}
            />)}
        </div>
      </>
    );
  }
}
